import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@letly/models';
import { CacheService } from '@letly/services';
import { PropertyDetailModel } from '@letly/models';
import { environment } from '../../../env/environment';

@Injectable({
  providedIn: 'root',
})
export class PropertyDetailService {
  private cacheService = inject(CacheService);

  getPropertyDetail(id: string): Observable<ApiResponse<PropertyDetailModel>> {
    return this.cacheService.get(environment.listingBaseUrl + `/v1/listed-properties/${id}`);
  }
}
